'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProjectShareRenderer = require('components/Projects/ProjectShareRenderer');

var _projectStubbedData = require('reducers/projectStubbedData');

var _projectStubbedData2 = _interopRequireDefault(_projectStubbedData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/* injects from baggage-loader */

// import { Base64 } from 'js-base64';

var STUB_PROJECT = (0, _projectStubbedData2.default)();

var authorName = 'Justin Biebah';
var projectTitle = 'Мой очень классный проект';

/*
const imageBase64 = getProjectShareImage({
  project: STUB_PROJECT,
  authorName, projectTitle,
  width: 1200,
  height: 630
});
*/

var width = 1200;
var height = 630;

var TestPage = function (_Component) {
  _inherits(TestPage, _Component);

  function TestPage() {
    _classCallCheck(this, TestPage);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(TestPage).apply(this, arguments));
  }

  _createClass(TestPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ProjectShareRenderer.ProjectShareRenderer, {
          project: STUB_PROJECT,
          authorName: authorName,
          projectTitle: projectTitle,
          width: width,
          height: height
        })
      );
    }
  }]);

  return TestPage;
}(_react.Component);

exports.default = TestPage;


//////////////////
// WEBPACK FOOTER
// ./app/components/Test/TestPage.js
// module id = 614
// module chunks = 1